import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatString'
})
export class FormatStringPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return value; // Handle empty input

    // Replace underscores with spaces
    const formattedString = value.replace(/_/g, ' ');

    // Capitalize the first letter of each word
    return formattedString
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
}
